import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Typography } from "@material-ui/core";
import TitleContainer from "../../LogoLinks/TitleContainer";
import parse from "html-react-parser";
import LayoutContainer from "../../../components/LayoutsContainer";
import { getImageUrl } from "../../../redux/types";
const useStyles = makeStyles((theme) => ({
  root: {
    padding: "5vh 0vw",
  },
  aboutUsImage: {
    height: "50vh",
    width: "100%",
    objectFit: "contain",
  },
  TitleContainer: {
    marginBottom: theme.spacing(2),
  },
}));

const AboutUsLayout = ({ data }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <LayoutContainer>
        <Grid container spacing={2}>
          <Grid item lg={6}>
            <img
              src={getImageUrl(data.image)}
              className={classes.aboutUsImage}
            />
          </Grid>

          <Grid
            item
            lg={6}
            container
            direction="column"
            alignItems="flex-start"
          >
            <Grid item className={classes.TitleContainer}>
              <TitleContainer title={data.title} />
            </Grid>

            <Grid item>
              <Typography>
                {data.data ? parse(data.data) : undefined}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </LayoutContainer>
    </div>
  );
};
export default AboutUsLayout;
